(function webpackUniversalModuleDefinition(root, factory) {
	if(typeof exports === 'object' && typeof module === 'object')
		module.exports = factory(require("react"), require("@alifd/next"), require("react-dom"), require("moment"));
	else if(typeof define === 'function' && define.amd)
		define(["react", "@alifd/next", "react-dom", "moment"], factory);
	else if(typeof exports === 'object')
		exports["BizComps"] = factory(require("react"), require("@alifd/next"), require("react-dom"), require("moment"));
	else
		root["BizComps"] = factory(root["React"], root["Next"], root["ReactDOM"], root["moment"]);
})(window, function(__WEBPACK_EXTERNAL_MODULE__0__, __WEBPACK_EXTERNAL_MODULE__26__, __WEBPACK_EXTERNAL_MODULE__30__, __WEBPACK_EXTERNAL_MODULE__35__) {
return 